import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { EcallDetailService, EcallEquipmentSummaryService } from '..';
import { DialogHelper, ExceptionHelper } from '../../../../helper';
import { DangerModalComponent } from '../../../shared/components/danger-modal/danger-modal.component';
import { SuccessModalComponent } from '../../../shared/components/success-modal/success-modal.component';
import { WarningModalComponent } from '../../../shared/components/warning-modal/warning-modal.component';
import { EcallService } from '../ecall.service';

@Component({
  selector: 'app-ecall-pdf-summary',
  templateUrl: './ecall-pdf-summary.component.html',
  styleUrls: ['./ecall-pdf-summary.component.css']
})
export class EcallPdfSummaryComponent implements OnInit {

  id = '';
  files: any[];
  dataTable: any;
  bsModalRef: BsModalRef;
  isDownloading = false;

  constructor(
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private exception: ExceptionHelper,
    private router: Router,
    private chRef: ChangeDetectorRef,
    // private ecallDetailService: EcallDetailService,
    private ecallService: EcallService,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
    this.route.params.subscribe(params => {
      this.id = params['id'];
      console.log(params);

    });
  }

  ngOnInit() {
    this.getEquipmentDetail();
  }

  getEquipmentDetail() {
    this.ecallService.getPDFs(this.id).subscribe(res => {
      this.files = res.SpeicalServiceReportsList;
    }, err => {
        this.files = [];
      }, () => {
        if ($.fn.dataTable.isDataTable('#pdfDataTable')) {
          $('#pdfDataTable').DataTable().destroy();
        }
  
        this.chRef.detectChanges();
        const table: any = $('#pdfDataTable');
        table.DataTable();
      });
    }
    
  download(fileId) {
    this.isDownloading = true;

    this.ecallService.downloadServiceReport(fileId).subscribe(data => {
      const blob = new Blob([data.file], { type: 'application/pdf' });
      saveAs(blob, data.fileName);
      this.isDownloading = false;
    }, error => {
      this.isDownloading = false;
      this.exception.showError(error, 'showDanModalBtn');
      // this.redirect = false;
    });
  }
  delete(fileId) {

    const initialState = {
      message: this.translate.instant('header.pdf'),
      ok: () => {
        this.ecallService.deletePDF(this.id, fileId).subscribe(res => {
          this.bsModalRef.hide();
          const initialState = {
            message: this.translate.instant('header.pdf'),
            type: 3,
            ok: () => {
              this.bsModalRef.hide();
              this.router.navigate([''], {skipLocationChange: true}).then(
                x => this.router.navigate(['/home/e-call/pdf/', this.id])
              )
            }
          };
          this.bsModalRef = this.modalService.show(SuccessModalComponent, { initialState });
            
        }, err => {
          console.log(err);
          const initialState = {
            message: err.error.message || this.translate.instant('msg.error'),
            ok: () => {
              this.bsModalRef.hide();
            }
          };
          this.bsModalRef = this.modalService.show(DangerModalComponent, { initialState })
        })
      }
    };
    this.bsModalRef = this.modalService.show(WarningModalComponent, { initialState });

  }


}


// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-pdf-summary/ecall-pdf-summary.component.ts